/**
 * Nolana theme — mega menu behaviour (desktop navigation).
 * Ported from tema-demo/assets/js/nolana.js "Mega menü".
 *
 * - Hover opens a panel and closes the others; leaving schedules a short delayed close.
 * - Click / tap on the trigger toggles the panel (touch devices have no hover).
 * - Keyboard: Enter/Space toggle, ArrowDown moves focus into the panel, Escape closes,
 *   focus leaving the item closes it.
 * - Clicking anywhere outside closes every panel.
 * Re-initialises on Theme Editor section reloads.
 */
(function () {
  "use strict";

  var CLOSE_DELAY = 140;

  function initMegaMenu(root) {
    var items = Array.prototype.slice.call((root || document).querySelectorAll("[data-mega-item]"));
    if (!items.length) return;

    var closeTimer = null;

    function setOpen(item, open) {
      var trigger = item.querySelector("[data-mega-trigger]");
      item.classList.toggle("is-open", open);
      if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false");
    }

    function closeAll(except) {
      items.forEach(function (item) {
        if (item !== except) setOpen(item, false);
      });
    }

    items.forEach(function (item) {
      if (item.dataset.megaReady) return;
      item.dataset.megaReady = "true";

      var trigger = item.querySelector("[data-mega-trigger]");
      var panel = item.querySelector("[data-mega-panel]");
      if (!trigger || !panel) return;

      function open() {
        clearTimeout(closeTimer);
        closeAll(item);
        setOpen(item, true);
      }

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          setOpen(item, false);
        }, CLOSE_DELAY);
      }

      item.addEventListener("mouseenter", open);
      item.addEventListener("mouseleave", scheduleClose);

      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        if (item.classList.contains("is-open")) {
          setOpen(item, false);
        } else {
          open();
        }
      });

      trigger.addEventListener("keydown", function (event) {
        if (event.key === "ArrowDown") {
          event.preventDefault();
          open();
          var firstLink = panel.querySelector("a, button");
          if (firstLink) firstLink.focus();
        }
      });

      item.addEventListener("focusout", function () {
        setTimeout(function () {
          if (!item.contains(document.activeElement)) setOpen(item, false);
        }, 10);
      });
    });

    if (!document.body.dataset.megaGlobalReady) {
      document.body.dataset.megaGlobalReady = "true";

      document.addEventListener("click", function (event) {
        if (!event.target.closest("[data-mega-item]")) {
          document.querySelectorAll("[data-mega-item].is-open").forEach(function (item) {
            setOpen(item, false);
          });
        }
      });

      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        var openItem = document.querySelector("[data-mega-item].is-open");
        if (!openItem) return;
        setOpen(openItem, false);
        var trigger = openItem.querySelector("[data-mega-trigger]");
        if (trigger) trigger.focus();
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initMegaMenu(document);
    });
  } else {
    initMegaMenu(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initMegaMenu(event.target);
  });
})();
